const Consts = {
    GROUP_PARAM : "frontParam",
    GROUP_HOME : "frontHome",
    GROUP_CACHE : "cacheFront",
    GROUP_LABELS : "labelFront",
    TIER : "front",
}

export default Consts